module.exports = __webpack_public_path__ + "static/img/danMuOpen.b9fe193c.png";